<template>
    <div>
        <div class="flex flex-col items-center mt-12">
            <h3 class="text-4xl font-bold">Select your industry</h3>
            <h3>This helps us give you more relevant recommendations</h3>
        </div>
        <form class="mt-12" action="">
            <div class="flex justify-evenly">
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="alcohol" value="alcohol">
                    <label class="font-bold" for="alcohol">Alcohol</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="animals" value="animals">
                    <label class="font-bold" for="animals">Animals</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="arts" value="arts">
                    <label class="font-bold" for="arts">Arts & Crafts</label>
                </div>
            </div>
            <div class="flex justify-evenly">
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="cosmetics" value="cosmetics">
                    <label class="font-bold" for="cosmetics">Cosmetics & Beauty</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="Electronics" value="Electronics">
                    <label class="font-bold" for="Electronics">Electronics</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="Entertainment" value="Entertainment">
                    <label class="font-bold" for="Entertainment">Entertainment & Toys</label>
                </div>
            </div>
            <div class="flex justify-evenly">
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="fashion" value="fashion">
                    <label class="font-bold" for="fashion">Fashion</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="food" value="food">
                    <label class="font-bold" for="food">Food</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="health" value="health">
                    <label class="font-bold" for="health">Health</label>
                </div>
            </div>
            <div class="flex justify-evenly">
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="household" value="household">
                    <label class="font-bold" for="household">Household & Stationary</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="jewellery" value="jewellery">
                    <label class="font-bold" for="jewellery">Jewellery</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="Living" value="Living">
                    <label class="font-bold" for="Living">Living & Family</label>
                </div>
            </div>
            <div class="flex justify-evenly">
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="Services" value="Services">
                    <label class="font-bold" for="Services">Services & Workshops</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="Sport" value="Sport">
                    <label class="font-bold" for="Sport">Sport</label>
                </div>
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="Work" value="Work">
                    <label class="font-bold" for="Work">Work Utilities</label>
                </div>
            </div>
            <div class="flex justify-center">
                <div class="w-56 border border-pink-200 bg-white pt-2 pb-2 m-2 pl-3">
                    <input type="radio" name="industry" id="Other" value="Other">
                    <label class="font-bold" for="Other">Other</label>
                </div>
            </div>
            <div class="flex justify-center mt-12">
                <button class="w-56 bg-blue-500 text-white pt-1 pb-1" @submit.prevent="">Continue</button>
            </div>
            <div class="flex justify-center mt-4">
                <button class="text-gray-500">Back</button>
            </div>    
         </form>
    </div>
</template>
<script>
    export default{
        name: "Page1",
    }
</script>
<style scoped>

</style>